import React from 'react';
import { Box, Typography, Grid, useMediaQuery, useTheme } from '@mui/material';
import antiFraImg from '../../assets/antiFraudeImage/homeFraude.svg';
import IconWht from '@components/antiFraud/Icons/IconWht';
import IconPhone from '@components/antiFraud/Icons/IconPhone';
import IconEmail from '@components/antiFraud/Icons/IconEmail';

const AntiFraudHome = () => {

  const { breakpoints } = useTheme();
  const isTable = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isLarge = useMediaQuery(breakpoints.only('xl'));

  return (
    <Box
      sx={{
        padding: isMobile || isTable ? '80px 10px' : '160px 40px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F2FAFC',
      }}
    >
      <Grid
        width={isTable || isMobile ? '100%' : isLarge ? '55%' : '80%'}
        direction={{ xs: 'column', sm: 'column', md: 'row' }}
        display={'flex'}
        justifyContent="space-between"
        alignItems={'center'}
      >
        <Grid
          sx={{
            display: 'flex',
            marginBottom: '60px',
            justifyContent: { xs: 'center', md: 'flex-end' },
          }}
        >
          <Box
            component="img"
            src={antiFraImg}
            alt="antiFraImg"
            sx={{
              display: 'flex',
              paddingTop: { xs: 0, sm: 0 },
            }}
          />
        </Grid>
        <Grid
          sx={{
            width: isTable ||isMobile ? '100%' : '80%',
          }}
        >
          <Typography
            component="h2"
            className="section-title"
            sx={{
              fontWeight: 700,
              fontSize: '24px',
              lineHeight: '34px',
              textAlign: isMobile || isTable ? 'center': 'left'
            }}
          >
            ¡Contratar en inter.mx es seguro, seguro!
          </Typography>

          <Box sx={{ marginTop: '24px' }}>
            <Typography
              variant="h5"
              style={{
                fontSize: isMobile ? '17px' : '18px',
                textAlign: isMobile || isTable ? 'center' : 'left',
              }}
            >
              Mantenemos tu información protegida. Recuerda que en inter.mx
              nunca te pediremos pagos a cuentas de terceros ni transferencias.
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 2,
              display: 'flex',
              height: 'auto',
              width: '100%',
              alignItems: 'center',
              justifyContent: { xs: 'center', sm: 'center', md: 'left' },
            }}
          >
            <Typography
              variant="h5"
              style={{
                fontSize: isMobile ? '17px' : '18px',
                textAlign: isTable || isMobile ? 'center' : 'left',
              }}
            >
              Si tienes alguna duda contáctanos en:
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexWrap: isMobile ? 'wrap' : 'nowrap',
              justifyContent: isTable || isMobile ? 'center' : 'left'
            }}
          >
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                height: 'auto',
                width: '100%',
                alignItems: 'center',
                justifyContent: { xs: 'center', sm: 'center', md: 'left' },
              }}
            >
              <IconWht />
              <Box
                component="a"
                sx={{
                  marginLeft: 1,
                  fontSize: '16px',
                  textAlign: 'left',
                  color: '#42b6da',
                  textDecoration: 'none',
                }}
                href="https://api.whatsapp.com/send/?phone=5547420824&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noreferrer"
              >
                55 4742 0824
              </Box>
            </Box>

            <Box
              sx={{
                mt: 2,
                display: 'flex',
                height: 'auto',
                width: '100%',
                alignItems: 'center',
                justifyContent: { xs: 'center', sm: 'left', md: 'left' },
              }}
            >
              <IconPhone />
              <Box
                component={'a'}
                style={{
                  marginLeft: 5,
                  fontSize: '16px',
                  textAlign: 'left',
                  color: '#42b6da',
                  textDecoration: 'none',
                }}
                href="tel:5544246837"
                target="_blank"
                rel="noreferrer"
              >
                55 442 46837
              </Box>
            </Box>

            <Box
              sx={{
                mt: 2,
                display: 'flex',
                height: 'auto',
                width: '100%',
                alignItems: 'center',
                justifyContent: { xs: 'center', sm: 'left', md: 'left' },
              }}
            >
              <IconEmail />
              <Box
                component={'a'}
                style={{
                  marginLeft: 5,
                  fontSize: '16px',
                  textAlign: 'left',
                  color: '#42b6da',
                  textDecoration: 'none',
                }}
                href="mailto:hola@inter.mx"
                target="_blank"
                rel="noreferrer"
              >
                hola@inter.mx
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: '40px',
              display: 'flex',
              height: 'auto',
              width: '100%',
              alignItems: 'center',
              justifyContent: { xs: 'center', sm: 'left', md: 'left' },
            }}
          >
            <Typography
              variant="h5"
              style={{
                fontSize: '18px',
                textAlign: 'center',
                width: '100%',
              }}
            >
              Estamos siempre para ayudarte
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default AntiFraudHome;
